import {
  CSSProperties,
  ReactNode,
  useRef,
  MouseEvent,
  MutableRefObject,
} from "react";
import classNames from "classnames";

import styles from "./Block.module.scss";

interface BlockProps {
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
  saveRef?: MutableRefObject<any>;
}

const Block = ({
  saveRef,
  children,
  style,
  className,
  onClick,
}: BlockProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleClick = (e: MouseEvent) => {
    if (ref.current?.contains(e.target as Node)) {
      onClick?.();
    }
  };

  return (
    <div
      ref={saveRef ? saveRef : ref}
      className={classNames(styles.block, className)}
      style={style}
      onClick={handleClick}
    >
      {children}
    </div>
  );
};

export default Block;
